module.exports = __webpack_public_path__ + "img/option_icon.ca66b492.svg";